//
// Copyright (c) 2023 Emplifi, Inc.
//

import {
  AnnotationsUIs,
  CommentsRepository,
  type CommentThreadDataJSON,
  InlineAnnotations,
  WideSidebar,
} from "ckeditor5-premium-features";
import { Plugin } from "ckeditor5";
import { responseTextHasComments } from "../baseModels/util";
// @ts-ignore
import Messenger from "messaging/messenger";

export class AkCommentsAdapter extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "AkCommentsAdapter";
  }

  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [CommentsRepository, AnnotationsUIs, InlineAnnotations, WideSidebar];
  }

  init() {
    this._syncComments();
  }

  private _syncComments() {
    const commentThreadsCollection = Messenger.reqres.request("response:commentThreads");
    const commentThreadsCollectionPromise = commentThreadsCollection.onSyncedPromise();
    // NOTE: Cannot use async/await, otherwise init() gets "stuck" and the CKEditor never loads
    // properly
    Promise.all([commentThreadsCollectionPromise]).then(() => {
      const haveNonResolvedComment = commentThreadsCollection.some(
        (commentThread: CommentThreadDataJSON) => !commentThread.resolvedAt,
      );

      const annotationsUIs = this.editor.plugins.get(AnnotationsUIs);

      const initialData = Messenger.reqres.request("editor:response:data");
      if (responseTextHasComments(initialData) && haveNonResolvedComment) {
        Messenger.reqres.request("editor:displayMode:wideSidebar", annotationsUIs);
      } else {
        Messenger.reqres.request("editor:displayMode:inline", annotationsUIs);
      }
    });
  }
}
